import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Register = () => {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        setMessage("✅ Compte créé ! Tu peux te connecter.");
        setForm({ name: "", email: "", password: "" });
        setTimeout(() => navigate("/login"), 700);
      } else {
        setMessage("❌ " + (data.error || "Erreur d’inscription"));
      }
    } catch {
      setMessage("❌ Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <Helmet>
        <title>Créer un compte – Deenzine</title>
        <meta name="description" content="Crée ton compte Deenzine pour suivre tes commandes et payer plus vite." />
        <link rel="canonical" href={window.location.origin + "/register"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 520, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Créer un compte</h1>
            <p className="p">En 30 secondes. Ensuite tu peux finaliser ton achat.</p>

            <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
              <label className="p" htmlFor="name" style={{ display: "block", marginBottom: 6 }}>
                Nom
              </label>
              <input
                id="name"
                name="name"
                className="input"
                value={form.name}
                onChange={handleChange}
                required
                autoComplete="name"
              />

              <div style={{ height: 12 }} />

              <label className="p" htmlFor="email" style={{ display: "block", marginBottom: 6 }}>
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="input"
                value={form.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />

              <div style={{ height: 12 }} />

              <label className="p" htmlFor="password" style={{ display: "block", marginBottom: 6 }}>
                Mot de passe
              </label>
              <input
                id="password"
                name="password"
                type="password"
                className="input"
                value={form.password}
                onChange={handleChange}
                required
                autoComplete="new-password"
              />

              <button className="btn" type="submit" disabled={loading} style={{ width: "100%", marginTop: 14 }}>
                {loading ? "Création…" : "S’inscrire"}
              </button>
            </form>

            {message && <div className="badge" style={{ marginTop: 14 }}>{message}</div>}

            <div style={{ marginTop: 14, textAlign: "center" }}>
              <Link to="/login" className="btn btnSecondary">
                J’ai déjà un compte
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Register;
